import { Certificate } from '@revenuemarket/bank';
import { Colors, Flex, Text } from '@revenuemarket/cds';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import useCertificatesQuery from '~hooks/queries/useCertificatesQuery';
import { useCompanyId } from '~hooks/useCompanyId';

const ListItem = ({ item, isLast }: { item: Certificate; isLast: boolean }) => {
  return (
    <Flex
      direction="column"
      gap={2}
      style={{
        borderBottom: isLast ? 'none' : `1px solid ${Colors.gray100}`,
        marginBottom: isLast ? 12 : 0,
        padding: '12px 0px',
      }}
    >
      <Text
        textStyle="13_500"
        style={{
          color: Colors.gray700,
        }}
      >
        {item.certificateOwner}
      </Text>
      <Text
        textStyle="13_400"
        style={{
          color: Colors.gray600,
        }}
      >
        {item.certificateAuthority || '금융결제원'}
        {' · '}
        {item.certificateType || '전자세금용'}
      </Text>
      <Text
        textStyle="13_400"
        style={{
          color: Colors.gray600,
        }}
      >
        만료일 {item.certificateExpireDate}
      </Text>
    </Flex>
  );
};

const RegisteredCertList = () => {
  const { companyId } = useCompanyId();
  const { data: certificate } = useCertificatesQuery(companyId);
  const certificateList = certificate?.Data?.data?.certificates || [];

  if (certificateList.length === 0) {
    return null;
  }

  return (
    <OverlayScrollbarsComponent
      style={{
        borderRadius: 12,
        border: `1px solid ${Colors.gray100}`,
        padding: '20px 20px 0px 20px',
        width: 320,
        height: 'max-content',
        maxHeight: `calc(100vh - 48px - 40px - 32px)`,
        overflowY: 'scroll',
      }}
    >
      <Flex direction="column" gap={8}>
        <Text textStyle="18_600">등록된 공동인증서</Text>
        {certificateList.map((item, index) => (
          <ListItem
            key={item.certificateOwner}
            item={item}
            isLast={index === certificateList.length - 1}
          />
        ))}
      </Flex>
    </OverlayScrollbarsComponent>
  );
};

export default RegisteredCertList;
